import { atom } from 'jotai';

import type { Appointment } from '../../../react-query/useAppointments';

export const claimSummaryAppointmentAtom = atom<Appointment | null>(null);

export const claimAttachmentIdAtom = atom<string | undefined>(undefined);
